import React                from 'react'
import { useQuery }         from '@apollo/client';
import { GET_PRO }          from '@core/ui/graphql/Pro.query';
import { useRouter }        from 'next/router';

import Pro         from '../../containers/Pro'
import PageMeta                     from '../../components/PageMeta';
import { getSidFromSlug , slugify } from '../../helpers/urlHandler';
import withLayout                   from '../../hoc/withLayout';
import simplePage  from '../../serverProps/simplePage';
import {Modal} from "@redq/reuse-modal";

const ProPage = props => {

    const router = useRouter() ;

    const { query : { slug : routerSlug } } = router ;

    const slug = getSidFromSlug( routerSlug ) ;
    const QUERY_VARIABLES = {
        id:slug,
    };

    const { data, loading, error } = useQuery(GET_PRO, {
        variables: QUERY_VARIABLES,
        //ssr:false
    });

    const { pro } = data || {} ;
    const { additionalType = null , alternateName = '' , description , imageProfil : avatar, sid } = pro || {};

    if( !loading && additionalType === null )
    {
        console.log('NOT FOUND ' ) ;
        return null;
    }

    let canonical = false;

    if (!loading) {
        canonical = `${process.env.SITE_URL}/pro/${slugify(alternateName)}-${sid}`;
    }

    return(
        <>
            <PageMeta
                title       = { alternateName }
                description = { description }
                image       = { avatar }
                canonical   = { canonical }
            />
            <Pro
                data = { data }
                error = { error }
                loading = { loading }
            />
            <Modal />
        </>
    );
}

export default withLayout( ProPage ) ;

export const getServerSideProps = simplePage;
